import { useToast } from '@/uiKit/Toast/useToast'

type ReturnType = {
  onSuccessfulCopy: () => void
  onFailedCopy: () => void
}

/**
 * Provides functions that can be used to handle the events emitted by
 * the uiKit <CodeBlock/> component, raising notifications to inform the
 * user of success/failure events.
 */
export const useCodeBlock = (): ReturnType => {
  const toast = useToast()

  const onSuccessfulCopy = (): void => {
    const notification = 'Command copied to clipboard'
    toast.success({ meta: { title: notification } })
  }

  const onFailedCopy = (): void => {
    toast.warning({
      meta: {
        title: "Couldn't copy content to clipboard.",
        desc: 'Please select the text and copy it manually.',
      },
    })
  }

  return { onSuccessfulCopy, onFailedCopy }
}
